// declare let pendo: any;

import { AnalyticsPlugin } from 'analytics';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- Pendo JS snippet
// @ts-ignore -- Pendo JS snippet
import pendoSnippet from './pendo.snippet.js';

const PLUGIN_NAME = 'pendo-analytics';

interface Pendo {
  // Based on https://developers.pendo.io/docs/?bash#agent-options
  initialize: (options: {
    visitor?: { id: string } & Record<string, unknown>;
    account?: { id: string };
    excludeTitle?: boolean;
    excludeAllText?: boolean;
    disableCookies?: boolean;
    disablePersistence?: boolean;
  }) => void;
  identify: (visitorId: string, accountId?: string) => void;
  track: (trackType: string, metadata?: unknown) => void;
  // This isn't one of the methods that the pendo snippet stubs out
  // So it can be undefined until the pendo script itself has loaded
  isReady?: () => boolean;
}

declare global {
  let pendo: Pendo;
}

function pendoNotLoaded() {
  return typeof pendo === 'undefined';
}

interface PluginConfig {
  apiKey?: string;
  excludeAllText?: boolean;
  excludeTitle?: boolean;
  disableCookies?: boolean;
  disablePersistence?: boolean;
  account?: {
    id: string;
  };
  visitor?: {
    id: string;
  } & Record<string, unknown>;
}

export function pendoAnalytics(userConfig: PluginConfig): AnalyticsPlugin {
  return {
    name: PLUGIN_NAME,
    config: userConfig,
    initialize: ({ config }: { config: PluginConfig }) => {
      if (!config.apiKey) {
        throw new Error('No Pendo API Key defined');
      }
      if (pendoNotLoaded()) {
        pendoSnippet(config.apiKey);
      }

      pendo.initialize({
        visitor: config.visitor,
        account: config.account,
        excludeTitle: userConfig.excludeTitle,
        excludeAllText: userConfig.excludeAllText,
        disableCookies: userConfig.disableCookies,
        disablePersistence: userConfig.disablePersistence,
      });
    },
    identify: ({ payload }: { payload: { userId: string } }) => {
      if (pendoNotLoaded()) {
        return;
      }

      pendo.identify(payload.userId);
    },
    track: ({ payload }: { payload: { properties: unknown; event: unknown } }) => {
      const { properties, event } = payload;

      pendo.track(event as string, properties);
    },
    loaded() {
      if (pendoNotLoaded()) {
        return false;
      }
      return !!pendo.isReady?.();
    },
  };
}
